import React from "react";
import { Button, Price } from "../index";

const CartItem = ({ id, img, style, name, type, size, totalPrice, totalCount, onRemove, onMinus, onPlus }) => {
  const handleRemoveClick = () => {
    onRemove(id);
  };

  const handlePlusItem = () => {
    onPlus(id);
  };

  const handleMinusItem = () => {
    onMinus(id);
  };
  return (
    <div className="cart__item grid between cross-center">
      <div className="grid cross-center">
        <div className={style + " cart__item-img"}>
          <img src={img} alt={name} />
        </div>
        <div className="cart__item-info hor-margin-20">{name}</div>
      </div>
      <div className="cart__item-count grid between cross-center">
        <div onClick={handleMinusItem} className="btn btn--outline btn--circle noselect">
          <span>-</span>
        </div>
        <div className="hor-padding-15">
          <strong>{totalCount}</strong>
        </div>
        <div onClick={handlePlusItem} className="btn btn--outline btn--circle noselect">
          <span>+</span>
        </div>
      </div>
      <div className="cart__item-price">
        <b>
          <Price price={totalPrice} />
        </b>
      </div>
      <div className="cart__item-remove">
        <Button onClick={handleRemoveClick} classes="btn--circle btn--outline noselect">
          <span>+</span>
        </Button>
      </div>
    </div>
  );
};

export default CartItem;
